"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.biLoggerTypesFilename = exports.RTL_LANGUAGES = exports.PAGE_COMPONENT_TYPE = exports.PLATFORM_WIDGET_COMPONENT_TYPE = exports.OOI_WIDGET_COMPONENT_TYPE = exports.DEFAULT_EDITOR_SDK_SRC = exports.DEFAULT_WIX_SDK_SRC = void 0;
var path_1 = __importDefault(require("path"));
exports.DEFAULT_WIX_SDK_SRC = 'https://static.parastorage.com/services/js-sdk/1.469.0/js/wix-private.min.js';
exports.DEFAULT_EDITOR_SDK_SRC = 'https://static.parastorage.com/services/js-platform-editor-sdk/1.917.0/lib/editorSDK.min.js';
exports.OOI_WIDGET_COMPONENT_TYPE = 'WIDGET_OUT_OF_IFRAME';
exports.PLATFORM_WIDGET_COMPONENT_TYPE = 'STUDIO_WIDGET';
exports.PAGE_COMPONENT_TYPE = 'PAGE_OUT_OF_IFRAME';
exports.RTL_LANGUAGES = [
    'ar',
    'arc',
    'bcc',
    'bqi',
    'ckb',
    'dv',
    'fa',
    'glk',
    'ha',
    'he',
    'khw',
    'ks',
    'ku',
    'mzn',
    'pnb',
    'ps',
    'sd',
    'ug',
    'ur',
    'yi',
];
exports.biLoggerTypesFilename = path_1.default.resolve(__dirname, './generated/bi-logger-types.d.ts');
//# sourceMappingURL=constants.js.map